import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'

// Является ли текущий пользователь участником отдела техподдержки
const useIsTechSupport = () => {
  const profile = useSelector(selectProfile)
  const dirtyTechSupportUsers = JSON.parse( useSelector((store: any) => store.settings.techSupportUsers) || '[]');
  const isTechSupportEnabled = useSelector((store: any) => store.settings.isTechSupportEnabled);
  const isChatEnabled = useSelector((store: any) => store.settings.isChatEnabled);

  const chatIsDisabledButTechnicalSupportIsEnabled = isChatEnabled != '1' && isTechSupportEnabled == '1'

  const settings = {
    dirtyTechSupportUsers,
    isTechSupportEnabled
  }

  const techSupportUsers = Array.isArray(dirtyTechSupportUsers)
    ? dirtyTechSupportUsers
    : []
  const isTechSupport =
    techSupportUsers.includes(profile.id) &&
    isTechSupportEnabled == '1'

  return { isTechSupport, settings, chatIsDisabledButTechnicalSupportIsEnabled }
}

export default useIsTechSupport
